<script lang="ts">
  import { Loader } from "lucide-svelte";

  export let spinColor: string = "#007bff";
  export let textColor: string = "#666666";
  export let text: string = "Loading...";
  export let size: number = 48;
</script>

<div class="spinner-container">
  <div class="spinner">
    <Loader {size} color={spinColor} class="spinner-icon" />
  </div>
  {#if text}
    <p class="spinner-text" style="color: {textColor}">{text}</p>
  {/if}
</div>

<style>
  .spinner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .spinner {
    margin-bottom: 20px;
  }

  :global(.spinner-icon) {
    animation: spin 5s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .spinner-text {
    font-size: 18px;
    text-align: center;
  }
</style>
